import { pendingText } from '../vault/writeQueue';
import { parseEntity } from './entity';
import type { VaultEntity } from './entity';

/**
 * The file as this tab holds it now: the write it still owes on it, else what the vault holds.
 * The write is asked after the read, so one queued while the vault was being read still wins.
 * Null where neither has the file.
 */
export async function heldEntity(
  vault: { readFile(path: string): Promise<string | null> },
  path: string,
): Promise<VaultEntity | null> {
  const read = await vault.readFile(path);
  const raw = pendingText(path) ?? read;
  return raw === null ? null : parseEntity(path, raw);
}
